import React from "react";

function InterviewResults({ results, searchTerm }) {
  return (
    <div>
      {results && results.interviews && results.interviews.interviews !== 0 && (
        <div className="resultsGroup">
          <div className="sectionTitle">Interviews</div>
          <div className="sectionList">
            <ul>
              {results && results.interviews && results.interviews.interviews !== 0 && results.interviews.results.map(interview => {
                return (
                  <li>
                    »{" "}
                    <a href={`//www.dreamchimney.com/interviews/${interview.interview_base_route}`}>
                      {" "}
                      Interview #{interview.interview_id}: {interview.interviewed}
                    </a>
                  </li>
                )
              }

              )}
            </ul>


          </div>
        </div>
      )}
    </div>
  );
}

export default InterviewResults;
